import { Box } from "@mui/material";
import image3 from "../../../assets/img/carousel/Slide-Ecoburgus-scaled.jpg";
import { useTheme } from "../../../Providers/ThemeProvider";
import { useLazyGetTownsQuery } from "../../../api/Town";
import { useCallback, useEffect, useState } from "react";
import { Town } from "../../../types/Town";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { Select } from "antd";
import "./TownView.css";

type Option = {
  label: string;
  value: number;
};

export default function TownView() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [getTowns] = useLazyGetTownsQuery();
  const [towns, setTowns] = useState<Town[]>();
  const [townsOptions, setTownsOptions] = useState<Option[]>([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    getTowns({}).then(
      ({ data }) => {
        if (data) {
          setTowns(data.list);
          setTownsOptions(
            data.list
              .map((town) => ({
                label: town.name,
                value: town.id,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))
          );
        }
      },
      () => {
        setError(true);
        setTowns([]);
      }
    );
  }, [getTowns]);

  const handleTownNavigate = (url: string) => {
    window.open(
      `${window.location.origin}/comuni/${url.replace(" ", "-")}`,
      "_blank"
    );
  };

  const onTownSelect = useCallback(
    (value: number) => {
      const selectedTown = towns!.find((town) => town.id === value);
      if (selectedTown) {
        handleTownNavigate(selectedTown.name);
      }
    },
    [towns]
  );

  const renderTowns = useCallback(() => {
    if (error)
      return (
        <span className="ms-2">
          C'è stato un errore, per favore riprova più tardi
        </span>
      );
    return towns!.length === 0 ? (
      <div>
        <p className="h4">Nessun Comune Presente in Archivio</p>
      </div>
    ) : (
      <div>
        <Select
          className="transparent-select"
          style={{ width: 250, alignItems: "center", color: "#FFF" }}
          placeholder="Scegli un Comune..."
          options={townsOptions}
          onChange={onTownSelect}
        />
      </div>
    );
  }, [error, towns, onTownSelect, townsOptions]);

  const renderAsyncContent = useCallback(() => {
    return towns ? (
      renderTowns()
    ) : (
      <div className="d-flex justify-content-center py-5 my-5">
        <TailSpin
          height={100}
          width={100}
          color={theme.colors.primary}
          radius="1"
        />
      </div>
    );
  }, [towns, renderTowns]);

  return (
    <div
      style={{
        position: "relative",
        height: "80vh",
        width: "100%",
        overflow: "auto",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
      }}
      className="slider-container"
    >
      <div
        style={{
          display: "flex",
          height: "100%",
          width: `100%`,
        }}
      >
        <div
          style={{
            backgroundImage: `url(${image3})`,
            height: "100%",
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          className="image"
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        />
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "#FFF",
          fontFamily: '"Roboto", sans-serif',
          display: "flex",
          flexDirection: "column",
          gap: 32,
          textAlign: "center", // opzionale
        }}
      >
        <Box
          style={{
            textTransform: "uppercase",
            fontSize: "14px",
            fontWeight: 600,
            letterSpacing: "12px",
          }}
        >
          Eco Burgus
        </Box>
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 48,
            fontWeight: 600,
            fontSize: "32px",
            lineHeight: "0.9em",
            color: "#FFF",
          }}
        >
          <span
            className="text-uppercase"
            style={{
              textTransform: "uppercase",
              fontSize: "24px",
              fontWeight: 600,
              letterSpacing: "8px",
            }}
          >
            I Comuni in cui operiamo
          </span>
          {renderAsyncContent()}
        </Box>
      </div>
    </div>
  );
}
